
// Equipment manuals data
export const EQUIPMENT_MANUALS = {
    // Audio Consoles
    'dlive': { searchWord: 'allen', name: 'Allen & Heath DLive', url: 'https://www.manua.ls/allen-and-heath/dlive-c3500/manual?p=9' },
    'avantis': { searchWord: 'allen', name: 'Allen & Heath Avantis', url: 'https://www.manua.ls/allen-and-heath/avantis/manual' },
    'sc48': { searchWord: 'avid', name: 'Avid Venue SC48', url: 'https://storage.googleapis.com/sfl-live/2016/01/SC48-User-Manual.pdf' },
    'wing': { searchWord: 'behringer', name: 'Behringer Wing', url: 'https://mediadl.musictribe.com/download/software/behringer/WING/WING_DAW_Documentation.pdf' },
    'digico': { searchWord: 'digico', name: 'DiGiCo SD and Quantum', url: 'https://digico.biz/wp-content/uploads/2022/03/SD-Quantum-Software-Reference-Issue-E-V1528.pdf' },
    'heritage': { searchWord: 'midas', name: 'Midas Heritage', url: 'https://www.manualslib.com/manual/2372341/Midas-Hd96-24-Cc-Tp.html?page=8#manual' },
    'soundcraft': { searchWord: 'soundcraft', name: 'Soundcraft VI', url: 'https://www.soundcraft.com/en-US/product_families/vi-series' },
    'ssl': { searchWord: 'ssl', name: 'SSL', url: 'https://livehelp.solidstatelogic.com/' },
    'cl': { searchWord: 'yamaha', name: 'Yamaha CL', url: 'https://usa.yamaha.com/files/download/other_assets/1/392941/cl5_3_1_en_rm_d1.pdf' },
    'pm5d': { searchWord: 'yamaha', name: 'Yamaha PM5D', url: 'https://www.manualslib.com/manual/196853/Yamaha-Pm5d.html' },
    'waves': { searchWord: 'waves', name: 'WAVES eMotion LV1', url: 'https://assets.wavescdn.com/pdf/soundgrid/emotion-lv1-mixer.pdf' },
  
    // PA Systems
    'adamson': { searchWord: 'adamson', name: 'Adamson', url: 'https://www.adamson.ai/support/downloads-directory' },
    'danley': { searchWord: 'danley', name: 'Danley', url: 'https://www.danleysoundlabs.com/our-products/product-type/' },
    'bag end': { searchWord: 'bag', name: 'Bag End', url: 'https://bagend.com/' },
    'ev': { 
      searchWord: 'electro-voice',
      name: 'Electro-Voice (EV)', 
      url: 'https://products.electrovoice.com/na/en/downloads-library/', 
      software: { 
        name: 'Electro-Voice Processing', 
        url: 'https://electrovoice.com/support/apps-and-tools/' 
      }
    },
    'funktion': { 
      searchWord: 'funktion-one',
      name: 'Funktion-One', 
      url: 'https://funktion-one.com/downloads/', 
      software: { 
        name: 'Funktion-One Software', 
        url: 'https://funktion-one.com/product-system/software' 
      }
    },
    'holoplot': { searchWord: 'holoplot', name: 'Holoplot', url: 'https://holoplot.com/' },
    'jbl': { 
      searchWord: 'jbl',
      name: 'JBL', 
      url: 'https://jblpro.com/en-US/product_families/performance-audio', 
      software: { 
        name: 'JBL Tour Market Software', 
        url: 'https://jblpro.com/en-US/product_families/tour-market-software' 
      }
    },
    'dB': { searchWord: 'db', name: 'dB', url: 'https://www.dbtechnologies.com/en/products/' },
    'eaw': { searchWord: 'eaw', name: 'EAW', url: 'https://eaw.com/documentation/' },
    'l-acoustics': { 
      searchWord: 'l-acoustics',
      name: 'L-Acoustics', 
      url: 'https://www.l-acoustics.com/loudspeakers/', 
      software: { 
        name: 'L-Acoustics Network Manager', 
        url: 'https://www.l-acoustics.com/products/network-manager/#' 
      }
    },
    'nexo': { searchWord: 'nexo', name: 'NEXO', url: 'https://www.nexo-sa.com/nexo-systems/', 
      software: { 
        name: 'Nexo NeMo Software', 
        url: 'https://www.nexo-sa.com/nemo/' 
      }
    },
    'meyer': { searchWord: 'meyer', name: 'Meyer Sound', url: 'https://meyersound.com/products/#current', software: { 
        name: 'Meyer Compass Software', 
        url: 'https://meyersound.com/product/compass/#overview' 
      }
    },
    'martin audio': { searchWord: 'martin', name: 'Martin Audio', url: 'https://martin-audio.com/products', software: { 
        name: 'Martin Audio Software', 
        url: 'https://martin-audio.com/support/software' 
      }
    },
    'tectonic': { searchWord: 'tectonic', name: 'Tectonic Audiolabs', url: 'https://www.tectonicaudiolabs.com/resources/' },
    'turbosound': { searchWord: 'turbosound', name: 'Turbosound', url: 'https://www.turbosound.com/downloads.html' },
    'vue': { searchWord: 'vue', name: 'Vue Audiotechnik', url: 'https://vue-audiotechnik.com/downloads/' },
  
    // Loudspeaker Processing
    'd&b': { searchWord: 'd&b', name: 'd&b R1 Software', url: 'https://www.dbaudio.com/global/en/products/software/r1/?prerender=1#tab-tutorials' },
    'lake': { searchWord: 'lake', name: 'LAKE Processing', url: 'https://www.lakeprocessing.com/technologies/' },
    'rivage': { searchWord: 'yamaha', name: 'Yamaha Rivage Console', url: 'https://usa.yamaha.com/files/download/other_assets/7/1159867/RIVAGE_PM_Series_OM_En_J1_views.pdf' },
    's6l': { searchWord: 'avid', name: 'Avid S6L Console', url: 'https://cdn-www.avid.com/-/media/avid/files/products-pdf/venue-s6l-system/venue_s6l_system_guide.pdf' },
    'midas pro': { searchWord: 'midas', name: 'Midas PRO Series', url: 'https://mediadl.musictribe.com/media/PLM/data/docs/P0BNJ/PRO2-PRO2C-Operators-Manual_OM_EN.pdf' },
  
    // Lighting
    'adb': { searchWord: 'adb', name: 'ADB Tenor', url: 'https://archive.org/details/adb-tenor-user-manual' },
    'adj': { searchWord: 'adj', name: 'ADJ', url: 'https://www.adj.com/controllers' },
    'avolites': { searchWord: 'avolites', name: 'Avolites', url: 'https://manual.avolites.com/docs' },
    'enigma m4': { searchWord: 'blizzard', name: 'Blizzard Enigma M4' , url: 'https://www.manualslib.com/manual/2289960/Blizzard-Lighting-Enigma-M4.html'},
    'blizzard': { searchWord: 'blizzard', name: 'Blizzard', url: 'https://www.blizzardpro.com/download-browser'},
    'chamsys': { searchWord: 'chamsys', name: 'ChamSys', url: 'https://chamsyslighting.com/pages/support' },
    'chauvet': { searchWord: 'chauvet', name: 'Chauvet', url: 'https://www.chauvetdj.com/downloads/' },
    'elation': { searchWord: 'elation', name: 'Elation CompuShow', url: 'https://www.manualslib.com/manual/43309/Elation-Compu-Live-Laptop-Pc.html' },
    'fleenor': { searchWord: 'doug', name: 'Doug Fleenor', url: 'https://www.dfd.com/pdf/127-data.pdf'},
    'etc': { searchWord: 'etc', name: 'ETC', url: 'https://www.etcconnect.com/Search-Documentation.aspx?DocType=137&LangType=1033' },
    'qlc': { searchWord: 'qlc+', name: 'QLC+ / JANDS', url: 'https://www.qlcplus.org/downloads/4.8.4/QLC+_manual_4.8.4.pdf' },
    'leprecon': { searchWord: 'leprecon', name: 'Leprecon', url: 'https://www.leprecon.com/manuals' },
    'm-light': { searchWord: 'martin', name: 'Martin M-Light', url: 'https://www.martin.com/en-US/support_downloads'},
    'm-touch': { searchWord: 'martin', name: 'Martin M-Touch', url: 'https://www.martin.com/en-US/support_downloads'},
    'onyx': { searchWord: 'obsidian', name: 'Obsidian Onyx', url: 'https://support.obsidiancontrol.com/Content/Onyx_Manual/Manual_Welcome.htm' },
    'showxpress': { searchWord: 'showxpress', name: 'ShowXpress', url: 'https://www.chauvetdj.com/showxpress/'},
    'sacn': { searchWord: 'sacn', name: 'sACN', url: 'https://sacnview.org/documentation.html'},
    'vista': { searchWord: 'vista', name: 'Vista by Chroma-Q', url: 'https://www.vistabychromaq.com/' },
    'claypaky': { searchWord: 'adb', name: 'ADB Claypaky Software', url: 'https://www.claypaky.it/family/adb-by-claypaky/' },
  
    'roland': { searchWord: 'roland', name: 'Roland V8-HD', url: 'https://proav.roland.com/global/videos/tutorial/V-8HD-HD-Video-Switcher/'}
  };
  
  // Function to find relevant manuals with uniqueness using Map
  export const findRelevantManuals = (venueData, equipment_manuals=EQUIPMENT_MANUALS) => {
    console.log('findRelevantManuals', venueData);
    console.log('equipment_manuals', equipment_manuals);
    console.log("--------------------------------");
    console.log("--------------------------------");
    // Create a Map to store unique manuals by their URL
    const relevantManuals = new Map();
    
    const addManual = (manual) => {
      // Use URL as the unique key since it should be unique for each manual
      if (!relevantManuals.has(manual.url)) {
        relevantManuals.set(manual.url, {
          name: manual.name,
          url: manual.url
        });
      }
    };
  
    const addSoftware = (software) => {
      if (software && !relevantManuals.has(software.url)) {
        relevantManuals.set(software.url, {
          name: software.name,
          url: software.url
        });
      }
    };
    
    if (venueData) {
      // PA System check
      if (venueData.pa) {
        const paText = venueData.pa.toLowerCase();
        Object.entries(equipment_manuals)
          .filter(([_, manual]) => manual.name.includes('Adamson') || 
                                 manual.name.includes('Danley') ||
                                 manual.name.includes('Bag End') ||
                                 manual.name.includes('Electro-Voice') ||
                                 manual.name.includes('Funktion-One') ||
                                 manual.name.includes('Holoplot') ||
                                 manual.name.includes('JBL') ||
                                 manual.name.includes('dB') ||
                                 manual.name.includes('EAW') ||
                                 manual.name.includes('L-Acoustics') ||
                                 manual.name.includes('NEXO') ||
                                 manual.name.includes('Meyer Sound') ||
                                 manual.name.includes('Martin Audio') ||
                                 manual.name.includes('Tectonic') ||
                                 manual.name.includes('Turbosound') ||
                                 manual.name.includes('Vue'))
          .forEach(([keyword, manual]) => {
            const keywordRegex = new RegExp(`\\b${manual.searchWord.toLowerCase()}\\b`, 'i');
            if (keywordRegex.test(paText)) {
              addManual(manual);
              if (manual.software) {
                addSoftware(manual.software);
              }
            }
          });
      }
      
      // FOH console check
      if (venueData.foh) {
        const fohText = venueData.foh.toLowerCase();
        Object.entries(equipment_manuals)
          .filter(([_, manual]) => manual.name.includes('Allen & Heath') || 
                                 manual.name.includes('Avid') ||
                                 manual.name.includes('Behringer') ||
                                 manual.name.includes('DiGiCo') ||
                                 manual.name.includes('Midas') ||
                                 manual.name.includes('Soundcraft') ||
                                 manual.name.includes('SSL') ||
                                 manual.name.includes('Yamaha') ||
                                 manual.name.includes('WAVES'))
          .forEach(([keyword, manual]) => {
            const keywordRegex = new RegExp(`\\b${manual.searchWord.toLowerCase()}\\b`, 'i');
            if (keywordRegex.test(fohText)) {
              addManual(manual);
              if (manual.software) {
                addSoftware(manual.software);
              }
            }
          });
      }
      
      // Lighting check
      if (venueData.lightingControl) {
        const lightingText = venueData.lightingControl.toLowerCase();
        Object.entries(equipment_manuals)
          .filter(([_, manual]) => manual.name.includes('ADB') || 
                                 manual.name.includes('ADJ') ||
                                 manual.name.includes('Avolites') ||
                                 manual.name.includes('Blizzard') ||
                                 manual.name.includes('Chauvet') ||
                                 manual.name.includes('Elation') ||
                                 manual.name.includes('Fleenor') ||
                                 manual.name.includes('ChamSys') ||
                                 manual.name.includes('ETC') ||
                                 manual.name.includes('QLC') ||
                                 manual.name.includes('Leprecon') ||
                                 manual.name.includes('Obsidian') ||
                                 manual.name.includes('Vista') ||
                                 manual.name.includes('ShowXpress') ||
                                 manual.name.includes('sACN') ||
                                 manual.name.includes('Martin') ||
                                 manual.name.includes('Claypaky'))
          .forEach(([keyword, manual]) => {
            const keywordRegex = new RegExp(`\\b${manual.searchWord.toLowerCase()}\\b`, 'i');
            if (keywordRegex.test(lightingText)) {
              addManual(manual);
              if (manual.software) {
                addSoftware(manual.software);
              }
            }
          });
      }
  
      if (venueData.video) {
        const videoText = venueData.video.toLowerCase();
        Object.entries(equipment_manuals)
          .filter(([_, manual]) => manual.name.includes('Roland'))
          .forEach(([keyword, manual]) => {
            const keywordRegex = new RegExp(`\\b${manual.searchWord.toLowerCase()}\\b`, 'i');
            if (keywordRegex.test(videoText)) {
              addManual(manual);
              if (manual.software) {
                addSoftware(manual.software);
              }
            }
          });
      }
    }
  
    // Fallback keyword search
    const { manualsLinks, ...venueDataForSearch } = venueData || {};
    const searchText = JSON.stringify(venueDataForSearch).toLowerCase();
    const problematicKeywords = ['cl', 'ev', 'etc'];
    
    Object.entries(equipment_manuals).forEach(([keyword, manual]) => {
      if (problematicKeywords.includes(keyword)) {
        return;
      }
      
      // Use word boundary regex for better matching
      const keywordRegex = new RegExp(`\\b${manual.searchWord.toLowerCase()}\\b`, 'i');
      if (keywordRegex.test(searchText)) {
        addManual(manual);
        if (manual.software) {
          addSoftware(manual.software);
        }
      }
    });
  
    console.log('relevantManuals', relevantManuals);
    // Convert Map values to array
    return Array.from(relevantManuals.values());
  };